import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-generic-tooltip',
  templateUrl: './generic-tooltip.component.html',
  styleUrls: ['./generic-tooltip.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule]
})
export class GenericTooltipComponent {

  @Input() tooltip!: any;
  @Input() left!: number;
  @Input() top!: number;
  @Input() position: string = '';
  @Input() anchorPos: string = '';
  childTemplate: TemplateRef<any> | any;
  isStringInput: boolean = false;


}
